import { DescribeProperty } from '../../common';

export class ProjectAccessControlPolicyAuthorizeResponse {
  @DescribeProperty({
    description: 'Token to access the project',
    type: 'string',
  })
  token: string;
}
